(function () {
  "use strict";

  var path = window.location.pathname;
  if (!path.includes("/collections/") && path !== "/collections/all" && !path.includes("/search")) return;

  var isSearch = path.includes("/search");

  var sidebar = document.getElementById("fa-filter-sidebar"),
    overlay = document.getElementById("fa-filter-overlay"),
    closeBtn = document.getElementById("fa-filter-close"),
    priceForm = document.getElementById("fa-price-filter-form");

  if (!sidebar) return;

  var annEl = document.getElementById("shopify-section-sections--18037980397681__header_announcements_9jGBFp"),
    hdrEl = document.getElementById("shopify-section-sections--18037980397681__header_section"),
    footerEl = document.getElementById("shopify-section-sections--18037980364913__footer_m9NzUG"),
    sidebarW = 220,
    bannerEl = (function () {
      var h = Array.from(document.querySelectorAll("h1, h2")).find(function (el) {
        return el.textContent.includes("All Products");
      });
      if (!h) return null;
      for (var cur = h, i = 0; i < 8 && cur.parentElement; i++) {
        if (cur.getBoundingClientRect().height > 100) return cur;
        cur = cur.parentElement;
      }
      return h;
    })(),
    bannerAbsBottom = (function () {
      if (isSearch) {
        return hdrEl ? Math.round(hdrEl.getBoundingClientRect().bottom + window.scrollY) : 208;
      }
      var gpSection = document.getElementById("shopify-section-template--18037980102769__gp_section_598549039281079180");
      if (gpSection) {
        var all = Array.from(gpSection.querySelectorAll("*")),
          tallest = all.reduce(function (best, el) {
            var h2 = el.getBoundingClientRect().height;
            return h2 > best.height ? { height: h2, bottom: el.getBoundingClientRect().bottom } : best;
          }, { height: 0, bottom: 0 });
        if (tallest.height > 50) return Math.round(tallest.bottom + window.scrollY);
      }
      var h = Array.from(document.querySelectorAll("h1, h2")).find(function (el) {
        return el.textContent.includes("All Products");
      });
      if (h)
        for (var cur = h, i = 0; i < 8 && cur.parentElement; i++) {
          if (cur.getBoundingClientRect().height > 100)
            return Math.round(cur.getBoundingClientRect().bottom + window.scrollY);
          cur = cur.parentElement;
        }
      return 358;
    })();

  function updateSidebarBounds() {
    var hdrBottom = hdrEl ? hdrEl.getBoundingClientRect().bottom : 208,
      bannerViewportBottom = bannerAbsBottom - window.scrollY,
      top = Math.max(hdrBottom, bannerViewportBottom),
      bottom = 0;
    if (footerEl) {
      var footerTop = footerEl.getBoundingClientRect().top;
      footerTop < window.innerHeight && (bottom = window.innerHeight - footerTop);
    }
    sidebar.style.top = top + "px";
    sidebar.style.bottom = bottom + "px";
  }

  function padProductGrid() {
    if (window.innerWidth <= 1199) return;
    if (isSearch) {
      var searchSection = document.getElementById("shopify-section-template--18037980332145__main");
      if (searchSection) {
        searchSection.style.setProperty("margin-left", sidebarW + "px", "important");
      }
      return;
    }
    var probe = document.elementFromPoint(sidebarW + 10, window.innerHeight * 0.6);
    if (probe)
      for (var el = probe, i = 0; i < 12 && !(!el || !el.parentElement); i++) {
        var rect = el.getBoundingClientRect();
        if (rect.left <= 20 && rect.width > window.innerWidth * 0.8) {
          var inner = el.children[0];
          inner && inner.style.setProperty("margin-left", sidebarW + "px", "important");
          break;
        }
        el = el.parentElement;
      }
  }

  function positionSortBar() {
    if (!(window.innerWidth > 900)) {
      var sortBar = document.querySelector(".fa-sort-bar");
      if (sortBar) {
        var bannerSection = document.getElementById("shopify-section-template--18037980102769__gp_section_598549039281079180");
        if (bannerSection) {
          var parent = bannerSection.parentElement;
          if (parent) {
            var afterBanner = bannerSection.nextSibling;
            afterBanner !== sortBar && parent.insertBefore(sortBar, afterBanner);
          }
        }
      }
    }
  }

  function updateMobileSortBar() {
    if (!(window.innerWidth > 900)) {
      var sortBar = document.querySelector(".fa-sort-bar");
      if (sortBar) {
        var header = document.getElementById("shopify-section-sections--18037980397681__header_section"),
          headerBottom = header ? Math.round(header.getBoundingClientRect().bottom) : 164,
          sortBarNaturalTop = sortBar.classList.contains("m-fixed")
            ? bannerAbsBottom
            : Math.round(sortBar.getBoundingClientRect().top + window.scrollY),
          shouldFix = window.scrollY + headerBottom >= bannerAbsBottom;
        shouldFix && !sortBar.classList.contains("m-fixed")
          ? (sortBar.classList.add("m-fixed"),
            sortBar.style.setProperty("top", headerBottom + "px", "important"),
            document.body.classList.add("fa-sort-fixed"),
            document.getElementById("MainContent") &&
              document.getElementById("MainContent").style.setProperty("padding-top", "52px", "important"))
          : !shouldFix && sortBar.classList.contains("m-fixed")
          ? (sortBar.classList.remove("m-fixed"),
            sortBar.style.removeProperty("top"),
            document.body.classList.remove("fa-sort-fixed"),
            document.getElementById("MainContent") &&
              document.getElementById("MainContent").style.removeProperty("padding-top"))
          : shouldFix && sortBar.style.setProperty("top", headerBottom + "px", "important");
      }
    }
  }

  updateSidebarBounds();
  padProductGrid();
  positionSortBar();
  updateMobileSortBar();
  reapplySwatchTruncation();

  window.addEventListener("scroll", updateSidebarBounds, { passive: true });
  window.addEventListener("scroll", updateMobileSortBar, { passive: true });
  window.addEventListener("resize", function () {
    updateSidebarBounds();
    padProductGrid();
    positionSortBar();
    updateMobileSortBar();
  });

  var filterSheet = document.getElementById("fa-filter-sheet"),
    sortSheet = document.getElementById("fa-sort-sheet");

  function openSheet(sheet) {
    sheet && (sheet.classList.add("open"), overlay && overlay.classList.add("open"), (document.body.style.overflow = "hidden"));
  }

  function closeSheet(sheet) {
    sheet &&
      (sheet.classList.remove("open"),
      document.querySelector(".fa-bottom-sheet.open") ||
        (overlay && overlay.classList.remove("open"), (document.body.style.overflow = "")));
  }

  function openSidebar() {
    sidebar.classList.add("open");
    overlay && overlay.classList.add("open");
    document.body.style.overflow = "hidden";
  }

  function closeSidebar() {
    sidebar.classList.remove("open");
    overlay && overlay.classList.remove("open");
    document.body.style.overflow = "";
  }

  document.querySelectorAll(".fa-filter-open-btn").forEach(function (btn) {
    btn.addEventListener("click", openSidebar);
  });
  closeBtn && closeBtn.addEventListener("click", closeSidebar);
  overlay &&
    overlay.addEventListener("click", function () {
      closeSidebar();
      closeSheet(filterSheet);
      closeSheet(sortSheet);
      overlay && overlay.classList.remove("open");
      document.body.style.overflow = "";
    });

  function bindToggles() {
    sidebar.querySelectorAll(".fa-filter-group-toggle").forEach(function (toggle) {
      toggle.addEventListener("click", function () {
        var collapsed = toggle.classList.toggle("collapsed"),
          opts = toggle.nextElementSibling;
        opts && opts.classList.toggle("hidden", collapsed);
      });
    });
    filterSheet &&
      filterSheet.querySelectorAll(".fa-filter-group-toggle").forEach(function (toggle) {
        toggle.addEventListener("click", function () {
          var collapsed = toggle.classList.toggle("collapsed"),
            opts = toggle.nextElementSibling;
          opts && opts.classList.toggle("hidden", collapsed);
        });
      });
  }

  bindToggles();

  var loadingOverlay = document.createElement("div");
  loadingOverlay.id = "fa-loading-overlay";
  loadingOverlay.innerHTML = '<div class="fa-spinner"></div>';
  document.body.appendChild(loadingOverlay);

  var spinnerStyle = document.createElement("style");
  spinnerStyle.textContent = [
    "#fa-loading-overlay {",
    "  display: none; position: fixed; inset: 0;",
    "  background: rgba(255,255,255,0.55);",
    "  z-index: 8999; align-items: center; justify-content: center;",
    "  backdrop-filter: blur(1px);",
    "}",
    "#fa-loading-overlay.visible { display: flex; }",
    ".fa-spinner {",
    "  width: 36px; height: 36px;",
    "  border: 3px solid rgba(210,33,41,0.15);",
    "  border-top-color: #d22129;",
    "  border-radius: 50%;",
    "  animation: fa-spin 0.7s linear infinite;",
    "}",
    "@keyframes fa-spin { to { transform: rotate(360deg); } }",
  ].join("");
  document.head.appendChild(spinnerStyle);

  function showLoader() {
    loadingOverlay.classList.add("visible");
  }

  function hideLoader() {
    loadingOverlay.classList.remove("visible");
  }

  function getProductGrid() {
    if (isSearch) return document.querySelector("#shopify-section-template--18037980332145__main .product-grid-container");
    return (
      document.getElementById("gIDGclFQC3") ||
      document.querySelector("GP-ROW[id]") ||
      document.querySelector('[class*="gzvoWgLRCP"]')
    );
  }

  function getGridFromHtml(html) {
    var parser = new DOMParser(),
      doc = parser.parseFromString(html, "text/html");
    if (isSearch) return doc.querySelector("#shopify-section-template--18037980332145__main .product-grid-container");
    return doc.getElementById("gIDGclFQC3") || doc.querySelector("GP-ROW[id]");
  }

  function getSidebarFromHtml(html) {
    var parser = new DOMParser(),
      doc = parser.parseFromString(html, "text/html");
    return doc.getElementById("fa-filter-sidebar");
  }

  function getFilterSheetFromHtml(html) {
    var parser = new DOMParser(),
      doc = parser.parseFromString(html, "text/html");
    return doc.getElementById("fa-filter-sheet");
  }

  var SWATCH_LIMIT = 3;

  function reapplySwatchTruncation() {
    document.querySelectorAll(".variant-option-group").forEach(function (group) {
      var items = Array.from(group.querySelectorAll(".option-item"));
      if (!(items.length <= SWATCH_LIMIT)) {
        var hidden = 0;
        items.forEach(function (item, i2) {
          i2 >= SWATCH_LIMIT
            ? (item.style.setProperty("display", "none", "important"), hidden++)
            : item.style.removeProperty("display");
        });
        var moreBtn = group.querySelector(".fa-swatch-more");
        if (!moreBtn && hidden > 0) {
          var productLink = group.closest('[data-product-url], a[href*="/products/"]'),
            href = productLink
              ? productLink.getAttribute("href") || productLink.getAttribute("data-product-url")
              : "#";
          if (href === "#")
            for (var el = group, i = 0; i < 10 && el; i++) {
              var a = el.querySelector('a[href*="/products/"]');
              if (a) { href = a.getAttribute("href"); break; }
              el = el.parentElement;
            }
          moreBtn = document.createElement("a");
          moreBtn.className = "fa-swatch-more";
          moreBtn.href = href || "#";
          moreBtn.innerHTML =
            '<span class="fa-swatch-more__plus">+</span><span class="fa-swatch-more__count">' + hidden + "</span>";
          moreBtn.setAttribute("aria-label", "+" + hidden + " more colors");
          group.appendChild(moreBtn);
        } else if (moreBtn) {
          var countEl = moreBtn.querySelector(".fa-swatch-more__count");
          countEl && (countEl.textContent = hidden);
          moreBtn.setAttribute("aria-label", "+" + hidden + " more colors");
          moreBtn.style.display = hidden > 0 ? "" : "none";
        }
      }
    });
  }

  function updateFilterCounts(url) {
    var params = Array.from(new URL(url, window.location.origin).searchParams.entries()).filter(function (p) {
      return p[0].startsWith("filter.");
    }),
      count = params.length;
    document.querySelectorAll(".fa-filter-count").forEach(function (el) {
      el.textContent = count;
      el.classList.toggle("visible", count > 0);
    });
  }

  function updateMobileFilterCount(url) {
    var mobileFilterCount = document.getElementById("fa-mobile-filter-count");
    if (mobileFilterCount) {
      var params = Array.from(new URL(url, window.location.origin).searchParams.entries()).filter(function (p) {
        return p[0].startsWith("filter.");
      }),
        count = params.length;
      mobileFilterCount.textContent = count;
      mobileFilterCount.classList.toggle("visible", count > 0);
    }
  }

  var debounceTimer = null,
    pendingDesktopUrl = null;

  function bindFilterLinks() {
    sidebar.querySelectorAll("a.fa-filter-option, a.fa-filter-chip, a.fa-filter-clear-all").forEach(function (link) {
      link.addEventListener("click", function (e) {
        e.preventDefault();
        var href = link.getAttribute("href");
        if (href) {
          pendingDesktopUrl = href;
          var isActive = link.classList.contains("active");
          link.classList.toggle("active", !isActive);
          var check = link.querySelector(".fa-filter-check");
          check && (check.style.background = isActive ? "" : "linear-gradient(135deg, #d22129 0%, #a01820 100%)");
          clearTimeout(debounceTimer);
          debounceTimer = setTimeout(function () {
            ajaxFilter(pendingDesktopUrl);
            pendingDesktopUrl = null;
          }, 400);
        }
      });
    });
  }

  var pendingSheetUrl = null;

  function bindSheetFilterLinks() {
    filterSheet &&
      (
        (pendingSheetUrl = window.location.href),
        filterSheet.querySelectorAll("a.fa-filter-option").forEach(function (link) {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            var href = link.getAttribute("href");
            if (href) {
              pendingSheetUrl = href;
              var isActive = link.classList.contains("active");
              link.classList.toggle("active", !isActive);
              var check = link.querySelector(".fa-filter-check");
              check &&
                ((check.style.background = isActive ? "" : "linear-gradient(135deg, #d22129 0%, #a01820 100%)"),
                (check.style.borderColor = isActive ? "" : "#d22129"));
              var applyBtn = filterSheet.querySelector(".fa-sheet-apply-btn"),
                activeCount = filterSheet.querySelectorAll("a.fa-filter-option.active").length;
              applyBtn && (applyBtn.textContent = activeCount > 0 ? "Apply & View (" + activeCount + ")" : "Apply & View");
            }
          });
        }),
        filterSheet.querySelectorAll("a.fa-filter-chip, a.fa-filter-clear-all").forEach(function (link) {
          link.addEventListener("click", function (e) {
            e.preventDefault();
            var href = link.getAttribute("href");
            href && ((pendingSheetUrl = href), closeSheet(filterSheet), ajaxFilter(href));
          });
        })
      );
  }

  var isLoading = false;

  function ajaxFilter(url) {
    isLoading ||
      ((isLoading = true),
      showLoader(),
      history.pushState({}, "", url),
      fetch(url, { headers: { "X-Requested-With": "XMLHttpRequest" } })
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var newGrid = getGridFromHtml(html),
            oldGrid = getProductGrid();
          newGrid &&
            oldGrid &&
            oldGrid.parentElement &&
            (oldGrid.parentElement.replaceChild(newGrid, oldGrid),
            setTimeout(function () { padProductGrid(); reapplySwatchTruncation(); }, 50));

          var newSidebar = getSidebarFromHtml(html);
          if (newSidebar && sidebar) {
            var newBody = newSidebar.querySelector(".fa-filter-body"),
              newActiveBar = newSidebar.querySelector(".fa-filter-active-bar"),
              oldBody = sidebar.querySelector(".fa-filter-body"),
              oldActiveBar = sidebar.querySelector(".fa-filter-active-bar");
            newBody && oldBody && oldBody.parentElement.replaceChild(newBody, oldBody);
            newActiveBar && oldActiveBar && oldActiveBar.parentElement.replaceChild(newActiveBar, oldActiveBar);
            bindToggles();
            bindFilterLinks();
          }

          var newSheet = getFilterSheetFromHtml(html);
          if (newSheet && filterSheet) {
            var newSheetBody = newSheet.querySelector(".fa-sheet-body"),
              newSheetActiveBar = newSheet.querySelector(".fa-sheet-active-bar"),
              oldSheetBody = filterSheet.querySelector(".fa-sheet-body"),
              oldSheetActiveBar = filterSheet.querySelector(".fa-sheet-active-bar");
            newSheetBody && oldSheetBody && oldSheetBody.parentElement.replaceChild(newSheetBody, oldSheetBody);
            newSheetActiveBar && oldSheetActiveBar && oldSheetActiveBar.parentElement.replaceChild(newSheetActiveBar, oldSheetActiveBar);
            bindToggles();
            bindSheetFilterLinks();
          }

          updateFilterCounts(url);
          updateMobileFilterCount(url);
        })
        .catch(function () { window.location.href = url; })
        .finally(function () { isLoading = false; hideLoader(); }));
  }

  bindFilterLinks();

  document.querySelectorAll(".fa-sort-select").forEach(function (sel) {
    sel.addEventListener("change", function () {
      var url = new URL(window.location.href);
      url.searchParams.set("sort_by", sel.value);
      ajaxFilter(url.toString());
    });
  });

  priceForm &&
    priceForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var min = priceForm.querySelector('[name="filter.v.price.gte"]').value,
        max = priceForm.querySelector('[name="filter.v.price.lte"]').value,
        url = new URL(window.location.href);
      min ? url.searchParams.set("filter.v.price.gte", parseFloat(min) * 100) : url.searchParams.delete("filter.v.price.gte");
      max ? url.searchParams.set("filter.v.price.lte", parseFloat(max) * 100) : url.searchParams.delete("filter.v.price.lte");
      ajaxFilter(url.toString());
    });

  updateFilterCounts(window.location.href);
  updateMobileFilterCount(window.location.href);

  window.addEventListener("popstate", function () { ajaxFilter(window.location.href); });

  var mobileFilterBtn = document.getElementById("fa-mobile-filter-open"),
    mobileSortBtn = document.getElementById("fa-mobile-sort-open"),
    filterSheetClose = document.getElementById("fa-filter-sheet-close"),
    sortSheetClose = document.getElementById("fa-sort-sheet-close"),
    filterSheetApply = document.getElementById("fa-filter-sheet-apply");

  mobileFilterBtn &&
    mobileFilterBtn.addEventListener("click", function () {
      pendingSheetUrl = window.location.href;
      var applyBtn = filterSheet && filterSheet.querySelector(".fa-sheet-apply-btn");
      applyBtn && (applyBtn.textContent = "Apply & View");
      openSheet(filterSheet);
    });
  mobileSortBtn && mobileSortBtn.addEventListener("click", function () { openSheet(sortSheet); });
  filterSheetClose && filterSheetClose.addEventListener("click", function () { closeSheet(filterSheet); });
  sortSheetClose && sortSheetClose.addEventListener("click", function () { closeSheet(sortSheet); });
  filterSheetApply &&
    filterSheetApply.addEventListener("click", function () {
      closeSheet(filterSheet);
      pendingSheetUrl && pendingSheetUrl !== window.location.href && ajaxFilter(pendingSheetUrl);
    });

  sortSheet &&
    sortSheet.querySelectorAll(".fa-sort-option").forEach(function (btn) {
      btn.addEventListener("click", function () {
        var sortVal = btn.getAttribute("data-sort"),
          url = new URL(window.location.href);
        url.searchParams.set("sort_by", sortVal);
        closeSheet(sortSheet);
        ajaxFilter(url.toString());
      });
    });

  var sheetPriceForm = document.getElementById("fa-price-filter-form-sheet");
  sheetPriceForm &&
    sheetPriceForm.addEventListener("submit", function (e) {
      e.preventDefault();
      var min = sheetPriceForm.querySelector('[name="filter.v.price.gte"]').value,
        max = sheetPriceForm.querySelector('[name="filter.v.price.lte"]').value,
        url = new URL(window.location.href);
      min ? url.searchParams.set("filter.v.price.gte", parseFloat(min) * 100) : url.searchParams.delete("filter.v.price.gte");
      max ? url.searchParams.set("filter.v.price.lte", parseFloat(max) * 100) : url.searchParams.delete("filter.v.price.lte");
      ajaxFilter(url.toString());
    });

  bindSheetFilterLinks();
})();